import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { FloorAclEffects } from './floor-acl.effects';
import { floorAclReducer } from './floor-acl.reducer';

export const provideFloorAclStore = () => [
  provideState('floorAcls', floorAclReducer),
  provideEffects([FloorAclEffects]),
];
